import React from "react";
import therapy from "../../assets/images/sak.jpeg";

const AboutUs = () => {
  return (
    <>
      <section className="about-section">
        <div className="about-container">
          <div className="about-images">
            <img src={therapy} alt="therapy" className="main-img" />
           
          </div>
          <div className="about-content">
            <h3>Our Story</h3>
            <h2>Our Story Sankalp Ayurveda</h2>
            <blockquote>
              Our journey began with a simple yet powerful belief — true healing
              comes from nature. At Sankalp Ayurveda, we are dedicated to
              bringing the timeless wisdom of Ayurveda into modern life through
              safe, effective, and high-quality herbal medicines. Our mission is
              to help people achieve long-lasting wellness naturally, without
              harmful chemicals or shortcuts.
            </blockquote>
            <p>
              Rooted in India’s rich Ayurvedic heritage, Sankalp Ayurveda
              combines ancient formulations with modern quality standards to
              ensure purity, consistency, and effectiveness. Every product is
              carefully crafted using ethically sourced herbs from trusted
              farms, forests, and Himalayan regions, preserving their natural
              strength and healing properties.
            </p>
            <div className="call-box">
              <div className="call-icon"> ☎︎ </div>
              <div>
                <strong>Call Us Now</strong>
                <p>+91 9211710043</p>
              </div>

              <div className="call-icon"> ✉️ </div>
              <div>
                <strong>Email </strong>
                <p>Sankalphealth10@gmail.com</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
